import { render, staticRenderFns } from "./ProfileUpdateRequests.vue?vue&type=template&id=a1357796&scoped=true&"
import script from "./ProfileUpdateRequests.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdateRequests.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUpdateRequests.vue?vue&type=style&index=0&id=a1357796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1357796",
  null
  
)

export default component.exports